<template>
    <div data-type="Schedule">
        <!-- <label v-text="field.label" class="block mb-2"></label> -->

        <div v-text="field.description"></div>

        <div class="flex flex-col lg:flex-row lg:-mx-2">
            <div class="lg:px-4 mb-4 lg:w-3/5">
                <calendar :attributes="attributes" @dayclick="dayClick" :min-date="new Date()" :disabled-dates='{ weekdays: [1, 7] }' />
            </div>
            <div class="lg:px-4 lg:w-2/5">
                <div>
                    <div
                        v-for="(d, d_key) in $store.state.data[this.field.id]"
                        :key="d_key"
                        class="rounded-md shadow-md flex lg:inline-flex mb-4 w-300 border-solid border-secondary-nonbinary-200 border"
                    >
                        <div
                            v-text="getDayOfTheWeek(d.date)"
                            class="border-r border-solid border-secondary-nonbinary-200 flex items-center justify-center w-1/4"
                        >
                            <div v-text="getDayOfTheWeek(d.date)"></div>
                        </div>

                        <div class="p-4 w-3/4">
                            <div class="text-center mb-2">
                                <div v-text="getDateString(d.date)"></div>
                            </div>
                            <div>
                                <select @input="setTime(d_key, $event)" tabindex="0" class="font-medium" aria-label="Please select a time preference">
                                    <option
                                        v-for="(time, time_key) in times"
                                        :key="time_key"
                                        :value="time"
                                        v-text="time"
                                    ></option>
                                </select>
                            </div>

                            <div class="text-center mt-2">
                                <button
                                    class="px-2 py-1 text-xs font-medium rounded hover:bg-gray-500"
                                    :class="`${$store.state.configs.button} ${$store.state.configs.button_text}`"
                                    @click="remove(d_key)"
                                >Remove</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Calendar from "v-calendar/lib/components/calendar.umd";

export default {
    data() {
        return {
            times: [
                "No Preference",
                "Early Morning",
                "Late Morning",
                "Early Afternoon",
                "Late Afternoon",
            ]
        };
    },
    methods: {
        remove(key) {
            let m = this.$store.state.data[this.field.id];
            m.splice(key, 1);

            this.$store.commit("updateData", {
                field: this.field.id,
                value: m,
            });
        },
        setTime(a, b) {
            let m = this.$store.state.data[this.field.id];

            m[a].time = b.target.value;

            this.$store.commit("updateData", {
                field: this.field.id,
                value: m,
            });
        },
        getDateString(day) {
            let d = new Date(day.replace(/-/g, "/").replace(/T.+/, ""));

            return (
                d.toLocaleString("default", { month: "long" }) +
                " " +
                d.getDate() +
                ", " +
                d.getFullYear()
            );
        },
        getDayOfTheWeek(day) {
            let d = new Date(day.replace(/-/g, "/").replace(/T.+/, ""));

            return this.$store.state.dayOfWeek[d.getDay()].substring(0, 3).toUpperCase();
        },
        dayClick(day) {
            if (day.isDisabled !== false) return;

            var days;

            if (typeof this.$store.state.data[this.field.id] == "object") {
                days = this.$store.state.data[this.field.id];
            } else {
                days = [];
            }

            let f = days.findIndex((e) => e.date == day.id);

            if (f !== -1) {
                days.splice(f, 1);
            } else {
                if (days.length >= 3) {
                    days.shift();
                }

                days.push({
                    date: day.id,
                    time: null,
                });
            }

            this.$store.commit("updateData", {
                field: this.field.id,
                value: days,
            });
        },
    },
    computed: {
        attributes() {
            return [
                {
                    key: "today",
                    highlight: true,
                    dates:
                        typeof this.$store.state.data[this.field.id] == "array"
                            ? this.$store.state.data[this.field.id].map(
                                  (e) =>
                                      new Date(
                                          e.date
                                              .replace(/-/g, "/")
                                              .replace(/T.+/, "")
                                      )
                              )
                            : [],
                },
            ];
        },
    },
    components: {
        Calendar,
    },
    props: ["field"],
};
</script>

<style lang="scss">
#vue-app {
    .w-300 {
        min-width: 300px;
    }

    .vc-container {
        width: 100%;
        border: 0;
    }
    @screen sm {
        .vc-container {
            width: 60%;
        }
    }
}
</style>